// @flow

import React from 'react';
import { Link } from '@riseart/common';
import { FullScreenIcon } from '@riseart/icons';

import { artistArtDetailLinkCls } from 'shared_components/artist/art/detail/Link.less';

type Props = {
  url: ?string,
  title: string,
};

/**
 * ArtistArtDetailLink
 *
 * @param {Props} props
 */
export const ArtistArtDetailLink = ({ url, title = '' }: Props) =>
  url ? (
    <Link obfuscate rel="nofollow" className={artistArtDetailLinkCls} to={url} title={title}>
      <FullScreenIcon />
    </Link>
  ) : null;
